import { atom } from "jotai";

export const showContinuePurchaseModalAtom = atom(false);
export const showOpenInAppModalAtom = atom(false);
